// extracted by mini-css-extract-plugin
export default {"projectWrapper":"project_projectWrapper__bFe-S","projectBackground":"project_projectBackground__hNg5h","projectTop":"project_projectTop__uW3KC"};